import {AlpineComponent} from "alpinejs";
import htmx from "htmx.org";

type FilterSelectAllComponent = AlpineComponent<{
	onSelectAllClick: () => void;
}>;

export default (): FilterSelectAllComponent => {
	return {
		onSelectAllClick() {
			const el = this.$el as HTMLInputElement;
			const ul = this.$el.closest('ul');
			if (ul) {
				const inputs = [...ul.querySelectorAll<HTMLInputElement>('input[type=checkbox]')];
				for (const input of inputs) {
					if (input === this.$el) {
						continue;
					}
					input.checked = el.checked;
				}
				if (inputs.length > 1) {
					htmx.trigger(inputs[1], 'change');
				}
			}
		}
	};
};
